"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deviceNameFactory = void 0;
var Bowser = require("bowser");
var models_1 = require("./models");
var create = function (navigator) {
    var deviceName;
    try {
        var browserInfo = Bowser.getParser(navigator.userAgent);
        deviceName = "".concat(browserInfo.getBrowserName(), " ").concat(browserInfo.getOSName()).trim();
    }
    catch (e) {
        deviceName = models_1.DeviceName.Browser;
    }
    return deviceName;
};
exports.deviceNameFactory = {
    create: create,
};
